/**
 * axios setup to use mock service
 */

// third-party
import axios from "axios";
import { dispatch } from "store";
import { setLoading } from "store/slices/global";

const axiosServices = axios.create({
  baseURL:
    window.location.href.indexOf("test") > -1 || window.location.href.indexOf("localhost") > -1
      ? `https://web-tools-api-test.funplus.com/ss/api/`
      : `https://web-tools-api.funplus.com/ss/api/`
});

axiosServices.interceptors.request.use(
  (config) => {
    if (config.headers) {
      const user = JSON.parse(localStorage.getItem("koa-webtools-auth") || "{}");
      const funplusConfig = JSON.parse(localStorage.getItem("funplus-config") || "{}");

      if (user?.openid) {
        config.headers["open_id"] = user?.openid as string;
      }

      config.headers["lang"] = funplusConfig.locale || "en";
    }

    dispatch(setLoading(true));
    return config;
  },
  (error) => Promise.reject(error || "Wrong Services")
);

// interceptor for http
axiosServices.interceptors.response.use(
  (response) => {
    dispatch(setLoading(false));
    return response;
  },
  (error) => {
    dispatch(setLoading(false));
    Promise.reject((error.response && error.response.data) || "Wrong Services");
  }
);

export default axiosServices;
